(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spore-home"] && !Shopify.designMode) return;
  try {
    

const audio = document.querySelector('#sample');
const play = document.querySelector('#play-main');
const symbol = document.querySelector('#play-symbol');
const progress = document.querySelector('#progress');
const status = document.querySelector('#audio-status');
function syncPlayer(){play.classList.toggle('is-playing',!audio.paused);symbol.textContent=audio.paused?'▶':'Ⅱ';play.setAttribute('aria-label',audio.paused?'Play audiobook preview':'Pause audiobook preview');}
async function toggleAudio(){if(!audio.paused){audio.pause();return;}try{await audio.play();status.textContent='';}catch{status.textContent='Playback could not start. Please try again.';}}
play.addEventListener('click',toggleAudio);
document.querySelector('[data-play="hero"]').addEventListener('click',()=>{document.querySelector('#listen').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});if(audio.paused)toggleAudio();});
audio.addEventListener('play',syncPlayer);audio.addEventListener('pause',syncPlayer);audio.addEventListener('ended',syncPlayer);
audio.addEventListener('timeupdate',()=>{progress.value=audio.currentTime;document.querySelector('#elapsed').textContent=Math.floor(audio.currentTime/60)+':'+String(Math.floor(audio.currentTime%60)).padStart(2,'0');});
progress.addEventListener('input',()=>{audio.currentTime=Number(progress.value);});
audio.addEventListener('error',()=>{status.textContent='The preview is temporarily unavailable. Please try again later.';});
const excerpt=document.querySelector('#excerpt-dialog'),edition=document.querySelector('#edition-dialog');
document.querySelector('#read-excerpt').addEventListener('click',()=>excerpt.showModal());
document.querySelectorAll('.close-dialog').forEach(b=>b.addEventListener('click',()=>b.closest('dialog').close()));
document.querySelector('.dialog-link').addEventListener('click',()=>excerpt.close());
document.querySelectorAll('dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}}));
const songSample=document.querySelector('#song-sample');
const songPanel=document.querySelector('#song-dialog-player');
document.querySelectorAll('[data-edition]').forEach(b=>b.addEventListener('click',()=>{
const isSong=b.dataset.edition==='song';
document.querySelector('#edition-title').textContent=b.dataset.title;
document.querySelector('#edition-description').textContent=b.dataset.description;
songPanel.hidden=!isSong;
document.querySelector('#dialog-preview').hidden=isSong;
edition.querySelector('.release-note').hidden=isSong;
songSample.pause();
if(isSong)audio.pause();
edition.showModal();
}));
songSample.addEventListener('play',()=>audio.pause());
audio.addEventListener('play',()=>songSample.pause());
songSample.addEventListener('error',()=>{document.querySelector('#song-preview-error').hidden=false;});
edition.addEventListener('close',()=>songSample.pause());
document.querySelector('#dialog-preview').addEventListener('click',()=>{edition.close();document.querySelector('#listen').scrollIntoView();if(audio.paused)toggleAudio();});

document.querySelectorAll('.header-menu a').forEach(link=>link.addEventListener('click',()=>{link.closest('details').open=false;}));document.addEventListener('keydown',e=>{if(e.key==='Escape'){const m=document.querySelector('.header-menu[open]');if(m){m.open=false;m.querySelector('summary').focus();}}});

if('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){const entranceObserver=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('luxury-arrive');entranceObserver.unobserve(entry.target);}});},{threshold:.08});document.querySelectorAll('.story-heading,.player,.edition,.author-grid article,.closing h2').forEach(el=>entranceObserver.observe(el));}

const sporeHero=document.querySelector('.atmospheric-hero');
if(sporeHero && matchMedia('(hover:hover) and (pointer:fine) and (prefers-reduced-motion:no-preference)').matches){sporeHero.addEventListener('pointermove',e=>{const r=sporeHero.getBoundingClientRect();sporeHero.style.setProperty('--spore-x',((e.clientX-r.left)/r.width-.5)*8+'px');sporeHero.style.setProperty('--spore-y',((e.clientY-r.top)/r.height-.5)*6+'px');},{passive:true});sporeHero.addEventListener('pointerleave',()=>{sporeHero.style.setProperty('--spore-x','0px');sporeHero.style.setProperty('--spore-y','0px');});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spore-wars"] && !Shopify.designMode) return;
  try {
    
(()=>{
const audio = document.querySelector('#sample');
const play = document.querySelector('#play-main');
const symbol = document.querySelector('#play-symbol');
const progress = document.querySelector('#progress');
const status = document.querySelector('#audio-status');
function syncPlayer(){symbol.textContent=audio.paused?'▶':'Ⅱ';play.setAttribute('aria-label',audio.paused?'Play audiobook preview':'Pause audiobook preview');}
async function toggleAudio(){if(!audio.paused){audio.pause();return;}try{await audio.play();status.textContent='';}catch{status.textContent='Playback could not start. Please try again.';}}
play.addEventListener('click',toggleAudio);
document.querySelector('[data-play="hero"]').addEventListener('click',()=>{document.querySelector('#listen').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});if(audio.paused)toggleAudio();});
audio.addEventListener('play',syncPlayer);audio.addEventListener('pause',syncPlayer);audio.addEventListener('ended',syncPlayer);
audio.addEventListener('timeupdate',()=>{progress.value=audio.currentTime;document.querySelector('#elapsed').textContent=Math.floor(audio.currentTime/60)+':'+String(Math.floor(audio.currentTime%60)).padStart(2,'0');});
progress.addEventListener('input',()=>{audio.currentTime=Number(progress.value);});
audio.addEventListener('error',()=>{status.textContent='The preview is temporarily unavailable. Please try again later.';});
const excerpt=document.querySelector('#excerpt-dialog'),edition=document.querySelector('#edition-dialog');
document.querySelector('#read-excerpt').addEventListener('click',()=>excerpt.showModal());
document.querySelectorAll('.close-dialog').forEach(b=>b.addEventListener('click',()=>b.closest('dialog').close()));
document.querySelector('.dialog-link').addEventListener('click',()=>excerpt.close());
document.querySelectorAll('dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}}));
const editionDetails = {
hardcover: {title:'The hardcover edition',description:'Spore Wars Alaska by Joseph Kuczmarski and Noreen Leuzzi. Approximately 480 pages, in a 6 × 9-inch hardcover.',note:'The hardcover will be purchased on Amazon. Its direct listing link is coming soon.'},
paperback: {title:'The paperback edition',description:'Spore Wars Alaska by Joseph Kuczmarski and Noreen Leuzzi, in paperback.',note:'The paperback will be purchased on Amazon. Its direct listing link is coming soon.'},
audiobook: {title:'The audiobook edition',description:'Approximately 7 hours 48 minutes, 57 chapters, English AI narration, and one continuous MP3. Includes the complete original theme song You Saved Me after the epilogue and before the author notes. Chapters 1, 6, and 44 contain less-graphic adaptations.',note:'Available to purchase here when sales open. Personal listening only; no redistribution or resale.',productId:'8084157202510',handle:'spore-wars-alaska-audiobook'},
song: {title:'You Saved Me',description:'The original closing theme from Spore Wars Alaska. Approximately 3 minutes 46 seconds, available as a separate MP3. This song is already included with the complete audiobook.',note:'Available to purchase here when sales open. Personal listening only; no redistribution or resale.',productId:'8084157300814',handle:'you-saved-me-theme-song'}
};
document.querySelectorAll('[data-edition]').forEach(button=>button.addEventListener('click',()=>{
const detail=editionDetails[button.dataset.edition];
document.querySelector('#edition-title').textContent=detail.title;
document.querySelector('#edition-description').textContent=detail.description;
document.querySelector('#release-message').textContent=detail.note;
edition.showModal();
}));
document.querySelector('#dialog-preview').addEventListener('click',()=>{edition.close();document.querySelector('#listen').scrollIntoView();if(audio.paused)toggleAudio();});

})();

  } catch(e) { console.error(e); }
})();
})();
